// Borrows section: shows both cash borrows (type=borrow txns) and credit-card debt breakdown.
import { Wallet, CreditCard } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { StatusPill } from "@/components/dashboard/StatusPill";

const fmt = (n) => Math.round(Number(n || 0)).toLocaleString();

export function BorrowsSection({ borrows, creditCards, ccy }) {
  const { t, lang } = useI18n();
  const empty = borrows.length === 0 && creditCards.length === 0;
  return (
    <section className="space-y-2 mb-4">
      <p className="text-xs font-bold text-slate-500 uppercase tracking-widest flex items-center gap-2">
        <Wallet className="w-3.5 h-3.5" /> {t("borrows")}
      </p>
      {empty && <p className="text-xs text-slate-400 py-2">—</p>}
      {creditCards.map((a) => {
        const used = Math.max(-Number(a.balance ?? a.opening_balance ?? 0), 0);
        const limit = Number(a.credit_limit || 0);
        return (
          <div key={`cc-${a.id}`} data-testid={`obl-cc-${a.id}`} className="p-2.5 rounded-xl neu-sm flex items-center gap-2">
            <CreditCard className="w-4 h-4 text-red-500 shrink-0" />
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold truncate">{a.name}</p>
              <p className="text-xs text-slate-500">
                {lang === "ar" ? "بطاقة ائتمانية" : "Credit card"}
                {limit > 0 && ` · ${fmt(limit)} ${ccy}`}
              </p>
            </div>
            <StatusPill status="unpaid" lang={lang} testId={`obl-cc-status-${a.id}`} />
            <span className="font-display font-extrabold text-sm tabular-nums text-red-600">{fmt(used)}</span>
          </div>
        );
      })}
      {borrows.map((b) => (
        <div key={b.id} className="p-2.5 rounded-xl neu-sm flex items-center gap-2">
          <p className="min-w-0 flex-1 text-sm font-semibold truncate">{b.description || b.category}</p>
          <StatusPill status="unpaid" lang={lang} testId={`obl-borrow-status-${b.id}`} />
          <span className="font-display font-extrabold text-sm tabular-nums text-red-600">{fmt(b.final_amount || b.amount || 0)}</span>
        </div>
      ))}
    </section>
  );
}
